var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "orcpub-reajuste" }, [
    _vm.TIPO == "PPA"
      ? _c(
          "table",
          [
            _c("thead", [
              _c(
                "tr",
                [
                  _c("th", { staticStyle: { width: "28%" } }, [
                    _vm._v("Projetos > Ações orçamentárias"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.years, function (year) {
                    return _c(
                      "th",
                      { key: year.name, staticStyle: { width: "18%" } },
                      [_vm._v(_vm._s(year.title))]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm._l(_vm.data.output, function (projeto) {
              return _c(
                "Fragment",
                { key: projeto.PROJETO },
                [
                  _c(
                    "tr",
                    [
                      _c("td", [
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(projeto.PROJETO) +
                              "\n                        "
                          ),
                          _c("div", { staticClass: "td-count" }, [
                            _vm._v(_vm._s(projeto.CHILDRENS.length)),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.years, function (year) {
                        return _c(
                          "td",
                          {
                            key: year.name,
                            attrs: { title: "Soma de valores" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "white-space": "nowrap",
                                  "align-items": "center",
                                  gap: "4px",
                                  "justify-content": "space-between",
                                  padding: "0 12px",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.formatMoney(
                                        _vm.calculateSum(projeto, year.name)
                                      )
                                    ) +
                                    "\n                        "
                                ),
                                _c("i", {
                                  staticClass: "fa fa-hashtag",
                                  staticStyle: {
                                    "font-size": "12px",
                                    color: "#bbbbbb",
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._l(projeto.CHILDRENS, function (acao, index) {
                    return _c(
                      "tr",
                      { key: acao.ACOESPROJETOS },
                      [
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "margin-left": "8px",
                                gap: "4px",
                                "justify-content": "flex-start",
                                position: "relative",
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 64 64",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M58 34L38 14H34V24H24C17.83 24 14 20.17 14 14H8V28C8 37.87 14.13 44 24 44H34V54H38L58 34Z",
                                      fill: "#95938E",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(acao.ACOESPROJETOS) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(acao.CLASSIFICACOES, function (classificacao) {
                          return _c("td", { key: classificacao }, [
                            _vm.data.values[classificacao].isEditing
                              ? _c("div", [
                                  _c("input", {
                                    ref: "inputRef",
                                    refInFor: true,
                                    attrs: { type: "text" },
                                    domProps: {
                                      value:
                                        _vm.data.values[classificacao]
                                          .VALORSTRING,
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.toggleEditMode(classificacao)
                                      },
                                      input: function (e) {
                                        return _vm.onInput(classificacao, e)
                                      },
                                    },
                                  }),
                                ])
                              : _c(
                                  "div",
                                  {
                                    class: _vm.data.values[classificacao]
                                      .canEdit
                                      ? "value"
                                      : "value null",
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleEditMode(classificacao)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatMoney(
                                          _vm.data.values[classificacao].VALOR
                                        )
                                      ) + "\n                        "
                                    ),
                                    _vm.data.values[classificacao].VALOR >
                                      _vm.data.values[classificacao]
                                        .VALORANTERIOR &&
                                    _vm.data.values[classificacao]
                                      .VALORANTERIOR != 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "percentage",
                                            staticStyle: {
                                              "background-color": "#A9D8E877",
                                              color: "#003C6E",
                                            },
                                            attrs: {
                                              title:
                                                "Valor Anterior: " +
                                                _vm.formatMoney(
                                                  _vm.data.values[classificacao]
                                                    .VALORANTERIOR
                                                ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.getPercentage(
                                                    _vm.data.values[
                                                      classificacao
                                                    ]
                                                  )
                                                ) +
                                                "\n                            "
                                            ),
                                            _c("i", {
                                              staticClass: "fa fa-caret-up",
                                              staticStyle: {
                                                "font-size": "12px",
                                                color: "currentColor",
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.data.values[classificacao].VALOR <
                                      _vm.data.values[classificacao]
                                        .VALORANTERIOR &&
                                    _vm.data.values[classificacao]
                                      .VALORANTERIOR != 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "percentage",
                                            staticStyle: {
                                              "background-color": "#F8CECC77",
                                              color: "#660000",
                                            },
                                            attrs: {
                                              title:
                                                "Valor Anterior: " +
                                                _vm.formatMoney(
                                                  _vm.data.values[classificacao]
                                                    .VALORANTERIOR
                                                ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.getPercentage(
                                                    _vm.data.values[
                                                      classificacao
                                                    ]
                                                  )
                                                ) +
                                                "\n                            "
                                            ),
                                            _c("i", {
                                              staticClass: "fa fa-caret-down",
                                              staticStyle: {
                                                "font-size": "12px",
                                                color: "currentColor",
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.data.values[classificacao].VALOR !=
                                      _vm.data.values[classificacao]
                                        .VALORANTERIOR &&
                                    _vm.data.values[classificacao]
                                      .VALORANTERIOR == 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "percentage",
                                            staticStyle: {
                                              "background-color": "#33aa3333",
                                            },
                                            attrs: { title: "Novo registro" },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-plus",
                                              staticStyle: {
                                                "font-size": "12px",
                                                color: "#33aa33",
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                          ])
                        }),
                      ],
                      2
                    )
                  }),
                ],
                2
              )
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }